import React, {Component} from 'react';

export default class FilterItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false,
        };

        this.onFilterItemClick = this.onFilterItemClick.bind(this);
    }

    onFilterItemClick() {
        if (this.props.isExpandable) {
            this.setState({
                isExpanded: !this.state.isExpanded,
            });
        } else {
            this.props.onActiveFilterUpdateCallback(this.props.categoryId, this.props.categoryParentId);
        }
    }

    render() {
        return (
            <li className={"post-feed__filters-item " + (this.props.isActive ? "active" : "")}>
                <button type="button" role="treeitem"
                        className={(this.props.isExpandable ? "post-feed__filters-item--expandable" : "") +
                        (this.state.isExpanded ? " expanded" : "") + " post-feed__filters-item-text"}
                        onClick={this.onFilterItemClick}
                        aria-expanded={this.props.isExpandable ? this.state.isExpanded : null}
                        aria-controls={this.props.isExpandable ? 'list-' + this.props.id : null}>
                    {this.props.isExpandable ? <span className="visually-hidden-accessible">Expand</span> : null}
                    {this.props.name} ({this.props.postCount})
                </button>

                {this.props.children ?
                    <ul className="post-feed__filters--sub" aria-hidden={!this.state.isExpanded}
                        id={'list-' + this.props.id} role="group">
                        <React.Fragment>
                            {this.props.children}
                        </React.Fragment>
                    </ul>
                    : null}
            </li>
        );
    }
}
